import { render, staticRenderFns } from "./OBtn.vue?vue&type=template&id=a490d502&scoped=true"
import script from "./OBtn.vue?vue&type=script&lang=js"
export * from "./OBtn.vue?vue&type=script&lang=js"
import style0 from "./OBtn.vue?vue&type=style&index=0&id=a490d502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a490d502",
  null
  
)

export default component.exports